import React, { useEffect, useState } from 'react';
import './Portfolio.css';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import ProjectsSection from './ProjectsSection';
import AboutSection from './AboutSection';
import ExperienceSection from './ExperienceSection';
import EducationSection from './EducationSection';
import BlogSection, { PUBLISHED_ARTICLES } from './BlogSection';
import CtaSection from './CtaSection';
import Footer from './Footer';
import useReveal from './hooks/useReveal';
import projects from './projects';
import { NAV_LINKS } from './profile';


// Hide the Blog link until at least one article is published
const links = NAV_LINKS.filter(l => l.key !== 'blog' || PUBLISHED_ARTICLES.length > 0);

const readTheme = () => {
    try {
        return localStorage.getItem('theme') === 'dark';
    } catch {
        return false;
    }
};

const Portfolio = () => {
    const [darkMode, setDarkMode] = useState(readTheme);
    const [activeFilter, setActiveFilter] = useState('All');
    const resumeRef = useReveal();

    useEffect(() => {
        try { localStorage.setItem('theme', darkMode ? 'dark' : 'light'); } catch { /* storage unavailable */ }
        document.documentElement.style.colorScheme = darkMode ? 'dark' : 'light';
    }, [darkMode]);

    return (
        <div className={`portfolio ${darkMode ? 'dark-mode' : ''}`}>
            <Navigation darkMode={darkMode} setDarkMode={setDarkMode} links={links} />

            <main>
                <HeroSection projectCount={projects.length} />
                <ServicesSection onSelectCategory={setActiveFilter} />
                <ProjectsSection
                    projects={projects}
                    activeFilter={activeFilter}
                    setActiveFilter={setActiveFilter}
                />
                <AboutSection />
                <section className="section resume" ref={resumeRef}>
                    <div className="container resume-grid">
                        <ExperienceSection />
                        <EducationSection />
                    </div>
                </section>
                <BlogSection />
                <CtaSection />
            </main>

            <Footer links={links} />
        </div>
    );
};

export default Portfolio;
